import { useEffect, useState } from 'react';
import { LocalTrackPublication, Participant, RemoteTrackPublication } from 'twilio-video';

type TrackPublication = LocalTrackPublication | RemoteTrackPublication;

const getParticipantPublications = (participant: Participant) =>
  Array.from(participant.tracks.values()) as TrackPublication[];

export default function usePublications(participant: Participant) {
  const [publications, setPublications] = useState<TrackPublication[]>(() => getParticipantPublications(participant));

  useEffect(() => {
    const syncPublications = () => {
      setPublications(getParticipantPublications(participant));
    };

    // Reset the publications when the 'participant' variable changes.
    syncPublications();

    const handleTrackPublished = () => syncPublications();
    const handleTrackUnpublished = () => syncPublications();

    participant.on('trackPublished', handleTrackPublished);
    participant.on('trackUnpublished', handleTrackUnpublished);
    return () => {
      participant.off('trackPublished', handleTrackPublished);
      participant.off('trackUnpublished', handleTrackUnpublished);
    };
  }, [participant]);

  return publications;
}
